/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React, { Fragment } from 'react'

import { EuiFlexItem, EuiTitle } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import GroupBySelect from '../GroupBySelect'
import useFilters from '../useFilters'
import { Action } from '../filtersReducer'

const GroupSection = () => {
  const { filters, dispatch } = useFilters()

  return (
    <Fragment>
      <EuiFlexItem grow={false}>
        <EuiTitle size='xxs'>
          <h5>
            <FormattedMessage
              id='billing-usage.filters.group-section.title'
              defaultMessage='Group data'
            />
          </h5>
        </EuiTitle>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <GroupBySelect
          value={filters.groupBy}
          onChange={(groupBy) =>
            dispatch({
              type: Action.SET_GROUP_BY,
              payload: groupBy,
            })
          }
        />
      </EuiFlexItem>
    </Fragment>
  )
}

export default GroupSection
